import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../utils/UserContext";
import axiosInstance from "../utils/axiosInstance";
import LoadingOverlay from "./LoadingOverlay";

const roles = {
  USER: 0,
  ADMIN: 1,
};
export function ProtectedComponent({ role = "USER", children }) {
  const { user, updateUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
    axiosInstance
      .post("/v51/sessions/token", {})
      .then((data) => {
        updateUser(data?.data);
        setDone(true);
      })
      .catch(() => {
        sessionStorage.removeItem("token");
        navigate("/login");
      });
  }, []);

  if (!done) {
    return <LoadingOverlay enabled={true} />;
  }
  if (!user?.role || roles[user.role] < roles[role]) {
    navigate("/login");
    return;
  }
  return children;
}
